var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button", id: "excel" },
              on: { click: _vm.imprimirExcel }
            },
            [
              _c("i", {
                staticClass: "fa fa-file-excel-o",
                attrs: { "aria-hidden": "true" }
              }),
              _c("span", [_vm._v("Excel")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button", id: "consultar" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", {
                staticClass: "fa fa-search",
                attrs: { "aria-hidden": "true" }
              }),
              _c("span", [_vm._v("Consultar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-group select2" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      multiple: "",
                      id: "rutas",
                      placeholder: "Todas...",
                      options: _vm.rutas,
                      label: "descripcion"
                    },
                    model: {
                      value: _vm.rutasSeleccionadas,
                      callback: function($$v) {
                        _vm.rutasSeleccionadas = $$v
                      },
                      expression: "rutasSeleccionadas"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "rutas" } }, [_vm._v("Rutas")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-inline form-inline--stretch" }, [
              _c("div", { staticClass: "form-inline__title" }, [
                _vm._v("\n              Fecha\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-inline__content" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipo_fecha == "P",
                        expression: "form.tipo_fecha == 'P'"
                      }
                    ],
                    staticClass: "d-flex gap-3"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "desde",
                              locale: "es",
                              "no-label": "",
                              "only-date": "",
                              "auto-close": "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fecha_desde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_desde", $$v)
                              },
                              expression: "form.fecha_desde"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Desde")])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              id: "hasta",
                              locale: "es",
                              "no-label": "",
                              "only-date": "",
                              "auto-close": "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione fecha..."
                            },
                            model: {
                              value: _vm.form.fecha_hasta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_hasta", $$v)
                              },
                              expression: "form.fecha_hasta"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Hasta")])
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("vue-good-table", {
                attrs: {
                  columns: [
                    {
                      label: "Ruta",
                      field: "ruta"
                    },
                    {
                      label: "Fecha",
                      field: "fecha"
                    },
                    {
                      label: "Cobro",
                      field: "cobro"
                    },
                    {
                      label: "Ingresos",
                      field: "ingresos"
                    },
                    {
                      label: "Egresos",
                      field: "egresos"
                    },
                    {
                      label: "Crédito",
                      field: "total_credito"
                    },
                    {
                      label: "Base",
                      field: "base"
                    },
                    {
                      label: "Vale",
                      field: "vale_base"
                    },
                    {
                      label: "Deposito",
                      field: "total_deposito"
                    },
                    {
                      label: "Microseguro",
                      field: "total_microseguro"
                    },
                    {
                      label: "Entregado",
                      field: "total_entregado"
                    },
                    {
                      label: "Gasto",
                      field: "gasto"
                    },
                    {
                      label: "Vale Final",
                      field: "vale"
                    },
                    {
                      label: "Saldo",
                      field: "saldo"
                    },
                    {
                      label: "Saldo Ruta",
                      field: "saldo_ruta"
                    }
                  ],
                  "pagination-options": {
                    enabled: true,
                    perPage: 20,
                    perPageDropdown: [],
                    nextLabel: "siguiente",
                    prevLabel: "anterior",
                    rowsPerPageLabel: "Registros por página",
                    ofLabel: "de",
                    allLabel: "Todo",
                    dropdownAllowAll: true
                  },
                  rows: _vm.registros,
                  "search-options": {
                    enabled: true,
                    placeholder: "Buscar..."
                  },
                  styleClass: "vgt-table vgt-table--sticky"
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-row",
                    fn: function(props) {
                      return [
                        props.column.field != "ruta" &&
                        props.column.field != "fecha"
                          ? _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      props.formattedRow[props.column.field]
                                    )
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte Diario de Caja")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20c6634c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c6634c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteDiarioCaja.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-20c6634c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteDiarioCaja.vue
// module chunks = 0